
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Sequence_generator_range
export function range(start: number, stop: number, step: number) {
    return Array.from({length: (stop - start) / step + 1}, (_, i) => start + (i * step));
}
